/**
 * Tracker-scoped cap maps; imported TC IDs never resolve to Voluum usage.
 * For Media Devoted | Created By Ciro Autiero
 */
import { matchTracker, trackerCan, trackerFromPlatform } from '@trafficpulse/shared';
import type { OfferCapUsageResponse } from '@/features/bank-stats/bank-stats.types';

export function capUsageFor(
  platform: string | null | undefined,
  usage?: OfferCapUsageResponse,
): OfferCapUsageResponse | undefined {
  const tracker = trackerFromPlatform(platform);
  if (!tracker) return undefined;
  return matchTracker(tracker, {
    voluum: () => usage,
    binom: () => usage,
    'tres-commas': () => (trackerCan('tres-commas', 'offerCaps') ? usage?.tresCommas : undefined),
  });
}
